(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-cart-transform"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('[data-bundle-section]');
    if (!section) return;
    if (section.dataset.bctInit === '1') return;
    section.dataset.bctInit = '1';

    const cfgEl = section.querySelector('[data-bundle-config]');
    const componentsEl = section.querySelector('[data-bundle-component-prices]');
    const metaEl = section.querySelector('[data-bundle-meta]');
    const assetsEl = section.querySelector('[data-bundle-assets]');
    if (!cfgEl || !metaEl) return;

    let config = {};
    let meta = {};
    let assets = {};
    try {
      config = JSON.parse(cfgEl.textContent || '{}');
      // Section setting `fallback_config` is rendered through `| json`, which
      // wraps the raw textarea as a JSON-encoded string. Unwrap once if so.
      if (typeof config === 'string') config = JSON.parse(config);
    } catch (e) { config = {}; }
    try { meta = JSON.parse(metaEl.textContent || '{}'); } catch (e) { meta = {}; }
    try { assets = (assetsEl && JSON.parse(assetsEl.textContent || '{}')) || {}; } catch (e) { assets = {}; }

    // colorAssets = bundle_color_galleries metaobjects. setColor.choices[].img/gallery
    // (bundle_config) take priority so the merchant edits one metafield, not two.
    const colorAssets = assets.colors || {};
    function _choiceFor(colorId) {
      const sc = config.setColor;
      if (!sc || !sc.choices) return null;
      return sc.choices.find(function (c) { return c.id === colorId; }) || null;
    }
    function colorImage(colorId) {
      const ch = _choiceFor(colorId);
      if (ch && ch.img) return ch.img;
      const c = colorAssets[colorId];
      return (c && c.image) || null;
    }
    function colorGallery(colorId) {
      const ch = _choiceFor(colorId);
      if (ch && ch.gallery && ch.gallery.length) return ch.gallery;
      const c = colorAssets[colorId];
      return (c && c.gallery) || [];
    }
    function colorVideos(colorId) {
      const c = colorAssets[colorId];
      const list = (c && c.videos) || [];
      return list.filter(function (v) { return v && v.src; }).slice(0, 3);
    }
    function bundleHeroForColor(colorId) { return colorImage(colorId); }
    function sharedKindUrl() { return null; }
    function thumbKindFor() { return null; }

    function imageForColor(item, colorId) {
      if (!item || !item.componentMap) return null;
      if (item.included) {
        const def = item.componentMap.default;
        return (def && def.img) || null;
      }
      const opts = item.options || [];
      const itemState = state[item.key] && state[item.key].selections;
      const keyParts = opts.map(function (o) {
        if (o.id === 'color') return colorId;
        return (itemState && itemState[o.id]) || o.default;
      });
      const map = item.componentMap;
      const composite = map[keyParts.join('/')];
      if (composite && composite.img) return composite.img;
      // Single-option components (bonnet/scrunchie) key by colorId alone.
      if (map[colorId] && map[colorId].img) return map[colorId].img;
      const firstKey = Object.keys(map)[0];
      return (map[firstKey] && map[firstKey].img) || null;
    }

    if (!config.items || !config.items.length) {
      const items = section.querySelector('[data-bundle-items]');
      if (items) items.innerHTML = '<div style="padding:16px;color:#5e728a">Bundle configuration missing.</div>';
      return;
    }

    const itemsHost = section.querySelector('[data-bundle-items]');
    const totalEl = section.querySelector('[data-bundle-total]');
    const saveTextEl = section.querySelector('[data-bundle-save-text]');
    const savePctEl = section.querySelector('[data-bundle-save-pct]');
    const cta = section.querySelector('[data-bundle-cta]');
    const toast = section.querySelector('[data-bundle-toast]');
    const timerEl = section.querySelector('[data-bundle-timer]');

    const state = {};
    config.items.forEach(function (it) {
      state[it.key] = { open: false, selections: {} };
      // Initialize non-color option defaults (e.g. size, scent). Color stays
      // un-set until the customer explicitly picks one — no swatch is
      // pre-highlighted, no per-color hero is auto-loaded.
      (it.options || []).forEach(function (o) {
        if (o.id === 'color') return;
        state[it.key].selections[o.id] = o.default;
      });
      if (it.sub) state[it.key].selections.sub = false;
    });
    if (config.items[0]) state[config.items[0].key].open = true;

    function money(n) {
      const sym = meta.currencySymbol || '$';
      return sym + Number(n).toFixed(2);
    }

    function variantFor(item, sel) {
      if (item.included) {
        const def = item.componentMap && item.componentMap.default;
        return { id: def && def.variantId, price: (def && def.price) || item.value || 0, variantId: def && def.variantId };
      }
      const opts = item.options || [];
      const keyParts = opts.map(function (o) { return sel[o.id]; });
      const key = keyParts.join('/');
      const map = item.componentMap || {};
      if (map[key]) return map[key];
      const fallbackKey = Object.keys(map)[0];
      return fallbackKey ? map[fallbackKey] : null;
    }

    // variantId (GID) → available bool. null = no SSR map present; treat
    // everything as available (graceful degradation).
    let inventory = null;

    function preloadInventory() {
      const invEl = section.querySelector('[data-bundle-inventory]');
      if (!invEl) return Promise.resolve();
      try {
        const parsed = JSON.parse((invEl.textContent || '{}').trim());
        inventory = (parsed && typeof parsed === 'object') ? parsed : null;
      } catch (e) { /* leave inventory null */ }
      return Promise.resolve();
    }

    function isVariantAvailable(variantId) {
      if (!inventory) return true;
      if (!variantId) return false;
      return inventory[variantId] !== false;
    }

    function isColorAvailable(colorId) {
      if (!inventory) return true;
      const groupKeys = (config.setColor && config.setColor.group) || [];
      for (let i = 0; i < groupKeys.length; i++) {
        const item = config.items.find(function (x) { return x.key === groupKeys[i]; });
        if (item && !itemHasAvailableComboForColor(item, colorId)) return false;
      }
      return true;
    }

    function itemHasAvailableComboForColor(item, colorId) {
      if (item.included) {
        const def = item.componentMap && item.componentMap.default;
        return isVariantAvailable(def && def.variantId);
      }
      const opts = item.options || [];
      const map = item.componentMap || {};
      const choiceLists = opts.map(function (o) {
        if (o.id === 'color') return [colorId];
        return (o.choices || []).map(function (c) { return typeof c === 'string' ? c : c.id; });
      });
      let found = false;
      (function walk(idx, parts) {
        if (found) return;
        if (idx === choiceLists.length) {
          const entry = map[parts.join('/')];
          if (entry && isVariantAvailable(entry.variantId)) found = true;
          return;
        }
        const list = choiceLists[idx];
        for (let j = 0; j < list.length && !found; j++) walk(idx + 1, parts.concat(list[j]));
      })(0, []);
      return found;
    }

    function isOptionChoiceAvailable(item, optId, choiceVal) {
      if (!inventory || item.included) return true;
      const opts = item.options || [];
      const sel = state[item.key] && state[item.key].selections;
      const map = item.componentMap || {};
      const parts = [];
      let scanColors = null;
      for (let i = 0; i < opts.length; i++) {
        const o = opts[i];
        if (o.id === optId) { parts.push(choiceVal); continue; }
        const cur = sel && sel[o.id];
        if (cur) { parts.push(cur); continue; }
        if (o.id === 'color') {
          scanColors = (o.choices || []).map(function (c) { return c.id; });
          parts.push(null);
          continue;
        }
        parts.push(o.default || (o.choices && o.choices[0] && (o.choices[0].id || o.choices[0])));
      }
      if (scanColors) {
        const colorIdx = opts.findIndex(function (o) { return o.id === 'color'; });
        for (let k = 0; k < scanColors.length; k++) {
          parts[colorIdx] = scanColors[k];
          const entry = map[parts.join('/')];
          if (entry && isVariantAvailable(entry.variantId)) return true;
        }
        return false;
      }
      const entry = map[parts.join('/')];
      return entry ? isVariantAvailable(entry.variantId) : true;
    }

    function currentSelectionOOS() {
      if (!inventory) return null;
      for (let i = 0; i < config.items.length; i++) {
        const item = config.items[i];
        const sel = state[item.key].selections;
        const v = variantFor(item, sel);
        const vid = v && (v.variantId || v.id);
        if (vid && !isVariantAvailable(vid)) return { item: item, variantId: vid };
      }
      return null;
    }

    function summaryLine(item, sel) {
      if (item.included) return 'Included';
      const parts = (item.options || []).map(function (o) {
        const v = sel[o.id];
        if (!v) return '';
        if (o.type === 'color' || o.type === 'scent') {
          const c = (o.choices || []).find(function (x) { return x.id === v; });
          return c ? c.name : '';
        }
        return v;
      }).filter(Boolean);
      if (item.sub) parts.push(sel.sub ? 'Subscribe & Save' : 'One-time');
      return parts.join('  ·  ');
    }

    function isComplete(item) {
      if (item.included) return true;
      const sel = state[item.key].selections;
      return (item.options || []).every(function (o) { return !!sel[o.id]; });
    }

    function renderItems() {
      const setColor = config.setColor || null;
      const groupKeys = (setColor && setColor.group) || [];
      const anchorKey = groupKeys[0] || null;
      const inSet = function (key) { return groupKeys.indexOf(key) !== -1; };
      // No fallback to setColor.default — color stays un-selected until the customer picks one.
      const setColorChoice = function () {
        if (!setColor) return null;
        const currentId = state[anchorKey] && state[anchorKey].selections.color;
        if (!currentId) return null;
        return (setColor.choices || []).find(function (c) { return c.id === currentId; }) || null;
      };

      itemsHost.innerHTML = '';

      if (setColor && anchorKey) {
        const anchorItem = config.items.find(function (x) { return x.key === anchorKey; });
        const cur = setColorChoice();
        const card = document.createElement('div');
        card.className = 'bct__set-card';
        const lbl = document.createElement('div');
        lbl.className = 'bct__set-card-label';
        lbl.textContent = 'Select Your Bundle ' + (setColor.label || 'Color');
        const valSpan = document.createElement('span');
        valSpan.className = 'bct__set-card-val';
        valSpan.textContent = cur ? cur.name : '';
        lbl.appendChild(document.createTextNode(': '));
        lbl.appendChild(valSpan);
        card.appendChild(lbl);
        if (setColor.note) {
          const note = document.createElement('div');
          note.className = 'bct__set-card-note';
          note.textContent = setColor.note;
          card.appendChild(note);
        }
        const row = document.createElement('div');
        row.className = 'bct__colors';
        (setColor.choices || []).forEach(function (c) {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'bct__color';
          btn.setAttribute('aria-pressed', (cur && cur.id === c.id) ? 'true' : 'false');
          const sw = document.createElement('span');
          sw.className = 'bct__color-sw';
          // Prefer bundle hero so the swatch shows the per-color bundle, not the variant component.
          const slotImg = c.img || colorImage(c.id) || (anchorItem && imageForColor(anchorItem, c.id));
          if (slotImg) {
            const img = document.createElement('img');
            img.src = slotImg; img.alt = c.name; img.loading = 'lazy';
            img.style.width = '100%'; img.style.height = '100%'; img.style.objectFit = 'cover'; img.style.display = 'block';
            sw.appendChild(img);
          } else {
            sw.style.background = c.sw || '#ccc';
          }
          const nm = document.createElement('span');
          nm.className = 'bct__color-name';
          nm.textContent = c.name;
          btn.appendChild(sw); btn.appendChild(nm);
          const colorOOS = !isColorAvailable(c.id);
          if (colorOOS) {
            btn.classList.add('is-sold-out');
            btn.disabled = true;
            btn.setAttribute('aria-disabled', 'true');
            btn.title = c.name + ' is sold out';
          }
          btn.addEventListener('click', function () { if (!colorOOS && anchorItem) pick(anchorItem, 'color', c.id); });
          row.appendChild(btn);
        });
        card.appendChild(row);
        itemsHost.appendChild(card);
      }

      config.items.forEach(function (item, idx) {
        const sel = state[item.key].selections;
        const stepEl = document.createElement('div');
        stepEl.className = 'bct__item' + (state[item.key].open ? ' is-open' : '') + (isComplete(item) ? ' is-complete' : '');
        stepEl.dataset.key = item.key;

        const head = document.createElement('button');
        head.type = 'button';
        head.className = 'bct__item-head';
        head.setAttribute('aria-expanded', state[item.key].open ? 'true' : 'false');

        const thumb = document.createElement('span');
        thumb.className = 'bct__item-thumb';
        const currentColor = sel.color;
        const thumbSrc = imageForColor(item, currentColor) || sharedKindUrl(thumbKindFor(item));
        if (thumbSrc) {
          const img = document.createElement('img');
          img.src = thumbSrc;
          img.alt = item.name || '';
          img.loading = 'lazy';
          thumb.appendChild(img);
        } else if (item.img) {
          const img = document.createElement('img');
          img.src = item.img;
          img.alt = item.name || '';
          img.loading = 'lazy';
          thumb.appendChild(img);
        }

        const info = document.createElement('span');
        info.className = 'bct__item-info';
        const nameWrap = document.createElement('span');
        nameWrap.className = 'bct__item-name';
        if (item.qty && item.qty > 1) {
          const b = document.createElement('b');
          b.textContent = item.qty + 'x ';
          nameWrap.appendChild(b);
        }
        nameWrap.appendChild(document.createTextNode(item.name || ''));
        const summary = document.createElement('span');
        summary.className = 'bct__item-summary';
        summary.textContent = summaryLine(item, sel);
        info.appendChild(nameWrap);
        info.appendChild(summary);

        const check = document.createElement('span');
        check.className = 'bct__item-check';
        check.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12l5 5L20 7" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        const chev = document.createElement('span');
        chev.className = 'bct__item-chevron';
        chev.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

        head.appendChild(thumb);
        head.appendChild(info);
        head.appendChild(check);
        head.appendChild(chev);
        head.addEventListener('click', function () { toggleOpen(item.key); });
        stepEl.appendChild(head);

        const body = document.createElement('div');
        body.className = 'bct__item-body';
        if (item.included) {
          const note = document.createElement('div');
          note.className = 'bct__item-summary';
          note.style.color = 'var(--bct-fg2)';
          note.textContent = 'Included with your bundle — no choices needed.';
          body.appendChild(note);
        } else {
          (item.options || []).forEach(function (o) {
            if (o.type === 'color' && setColor && inSet(item.key)) return;
            const wrap = document.createElement('div');
            const label = document.createElement('div');
            label.className = 'bct__option-label';
            label.textContent = o.label || o.id;
            if (o.type === 'color') {
              const valSpan = document.createElement('span');
              valSpan.className = 'bct__option-val';
              const cur = (o.choices || []).find(function (c) { return c.id === sel[o.id]; });
              valSpan.textContent = ': ' + (cur ? cur.name : '');
              label.appendChild(valSpan);
            }
            wrap.appendChild(label);
            if (o.type === 'color') {
              const row = document.createElement('div');
              row.className = 'bct__colors';
              (o.choices || []).forEach(function (c) {
                const btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'bct__color';
                btn.setAttribute('aria-pressed', sel[o.id] === c.id ? 'true' : 'false');
                const sw = document.createElement('span');
                sw.className = 'bct__color-sw';
                const slotImg = imageForColor(item, c.id);
                if (slotImg) {
                  const img = document.createElement('img');
                  img.src = slotImg;
                  img.alt = c.name;
                  img.loading = 'lazy';
                  img.style.width = '100%';
                  img.style.height = '100%';
                  img.style.objectFit = 'cover';
                  img.style.display = 'block';
                  sw.appendChild(img);
                } else {
                  sw.style.background = c.sw || c.color || '#ccc';
                }
                const nm = document.createElement('span');
                nm.className = 'bct__color-name';
                nm.textContent = c.name;
                btn.appendChild(sw);
                btn.appendChild(nm);
                const cOOS = !isOptionChoiceAvailable(item, o.id, c.id);
                if (cOOS) {
                  btn.classList.add('is-sold-out');
                  btn.disabled = true;
                  btn.setAttribute('aria-disabled', 'true');
                }
                btn.addEventListener('click', function () { if (!cOOS) pick(item, o.id, c.id); });
                row.appendChild(btn);
              });
              wrap.appendChild(row);
            } else if (o.type === 'pill') {
              const row = document.createElement('div');
              row.className = 'bct__pills';
              (o.choices || []).forEach(function (c) {
                const v = typeof c === 'string' ? c : c.id;
                const lbl = typeof c === 'string' ? c : (c.name || c.id);
                const btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'bct__pill';
                btn.setAttribute('aria-pressed', sel[o.id] === v ? 'true' : 'false');
                btn.textContent = lbl;
                const pOOS = !isOptionChoiceAvailable(item, o.id, v);
                if (pOOS) {
                  btn.classList.add('is-sold-out');
                  btn.disabled = true;
                  btn.setAttribute('aria-disabled', 'true');
                }
                btn.addEventListener('click', function () { if (!pOOS) pick(item, o.id, v); });
                row.appendChild(btn);
              });
              wrap.appendChild(row);
            } else if (o.type === 'scent') {
              const row = document.createElement('div');
              row.className = 'bct__scents';
              row.style.gridTemplateColumns = 'repeat(' + (o.choices || []).length + ', minmax(0, 1fr))';
              const thumb = sharedKindUrl('pm') || item.img;
              (o.choices || []).forEach(function (c) {
                const btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'bct__color';
                btn.setAttribute('aria-pressed', sel[o.id] === c.id ? 'true' : 'false');
                const sw = document.createElement('span');
                sw.className = 'bct__color-sw';
                sw.style.width = '50px';
                sw.style.height = '50px';
                if (thumb) {
                  const img = document.createElement('img');
                  img.src = thumb;
                  img.alt = c.name;
                  img.loading = 'lazy';
                  img.style.width = '100%';
                  img.style.height = '100%';
                  img.style.objectFit = 'cover';
                  img.style.display = 'block';
                  sw.appendChild(img);
                } else {
                  sw.style.background = 'var(--bct-bg-field)';
                }
                const nm = document.createElement('span');
                nm.className = 'bct__color-name';
                nm.textContent = c.name;
                nm.style.font = '500 11px/1.2 var(--bct-font-ui)';
                nm.style.whiteSpace = 'normal';
                nm.style.textAlign = 'center';
                btn.appendChild(sw);
                btn.appendChild(nm);
                const sOOS = !isOptionChoiceAvailable(item, o.id, c.id);
                if (sOOS) {
                  btn.classList.add('is-sold-out');
                  btn.disabled = true;
                  btn.setAttribute('aria-disabled', 'true');
                }
                btn.addEventListener('click', function () { if (!sOOS) pick(item, o.id, c.id); });
                row.appendChild(btn);
              });
              wrap.appendChild(row);
            }
            body.appendChild(wrap);
          });
          if (item.sub) {
            const lbl = document.createElement('label');
            lbl.className = 'bct__sub';
            const chk = document.createElement('input');
            chk.type = 'checkbox';
            chk.checked = !!sel.sub;
            chk.addEventListener('change', function () { pick(item, 'sub', chk.checked); });
            const text = document.createElement('span');
            text.innerHTML = 'Subscribe & Save 15% on refills <span class="bct__sub-note">— cancel anytime</span>';
            lbl.appendChild(chk);
            lbl.appendChild(text);
            body.appendChild(lbl);
          }
        }
        stepEl.appendChild(body);
        itemsHost.appendChild(stepEl);
      });
      updateDetailsAccordion();
    }

    // Keeps the Details accordion's Color + Pillowcase Size lines in sync
    // with the customer's current bundle selections. Called from renderItems
    // (which runs on every state change) and once at init.
    function updateDetailsAccordion() {
      const colorEl = section.querySelector('[data-bct-detail-color]');
      const sizeEl = section.querySelector('[data-bct-detail-size]');
      if (!colorEl && !sizeEl) return;
      if (colorEl) {
        const setColor = config.setColor;
        let colorName = '—';
        if (setColor) {
          const anchorKey = (setColor.group || [])[0];
          const sel = anchorKey && state[anchorKey] && state[anchorKey].selections;
          const cid = sel && sel.color;
          const choice = cid && (setColor.choices || []).find(function (c) { return c.id === cid; });
          if (choice) colorName = choice.name;
        }
        colorEl.textContent = colorName;
      }
      if (sizeEl) {
        const pcSel = state['pillowcase'] && state['pillowcase'].selections;
        sizeEl.textContent = (pcSel && pcSel.size) ? pcSel.size : '—';
      }
    }

    function toggleOpen(key) {
      config.items.forEach(function (it) {
        state[it.key].open = (it.key === key) ? !state[it.key].open : false;
      });
      renderItems();
    }

    function pick(item, optId, val) {
      const sel = state[item.key].selections;
      sel[optId] = val;
      if (optId === 'color') {
        applySharedColor(val);
        swapMainImage(val);
        syncThumbs(val);
        updateInsideCards(val);
        updateVideos(val);
      }
      if (optId !== 'sub' && isComplete(item)) {
        const idx = config.items.findIndex(function (x) { return x.key === item.key; });
        const next = config.items[idx + 1];
        if (next && !isComplete(next)) {
          config.items.forEach(function (it) { state[it.key].open = it.key === next.key; });
        }
      }
      renderItems();
      refreshTotal();
    }

    function applySharedColor(colorId) {
      config.items.forEach(function (it) {
        const colorOpt = (it.options || []).find(function (o) { return o.id === 'color'; });
        if (!colorOpt) return;
        if ((colorOpt.choices || []).some(function (c) { return c.id === colorId; })) {
          state[it.key].selections.color = colorId;
        }
      });
    }

    function swapMainImage(colorId) {
      const main = section.querySelector('[data-bundle-main-img]');
      if (!main) return;
      const url = bundleHeroForColor(colorId);
      if (url) main.src = url;
    }

    function syncThumbs(colorId) {
      const gallery = colorGallery(colorId);
      const thumbs = section.querySelectorAll('.bct__thumb');
      if (!thumbs.length) return;
      if (!gallery.length) {
        thumbs.forEach(function (thumb) { thumb.style.display = ''; });
        return;
      }
      thumbs.forEach(function (thumb, idx) {
        const img = thumb.querySelector('img');
        if (!img) return;
        if (gallery[idx]) {
          img.src = gallery[idx];
          img.removeAttribute('srcset');
          thumb.style.display = '';
        } else {
          thumb.style.display = 'none';
        }
      });
    }

    function updateInsideCards(colorId) {
      if (!colorId) return;
      const cards = document.querySelectorAll('[data-bundle-inside-card]');
      if (!cards.length) return;
      cards.forEach(function (card) {
        const key = card.getAttribute('data-bundle-inside-key');
        if (!key) return;
        const item = config.items.find(function (it) { return it.key === key; });
        if (!item) return;
        const url = imageForColor(item, colorId);
        if (!url) return;
        const imgEl = card.querySelector('[data-bundle-inside-img]');
        if (!imgEl) return;
        if (imgEl.tagName === 'IMG') {
          imgEl.setAttribute('src', url);
        } else {
          const replacement = document.createElement('img');
          replacement.setAttribute('src', url);
          replacement.setAttribute('alt', item.name || '');
          replacement.setAttribute('width', '360');
          replacement.setAttribute('height', '360');
          replacement.setAttribute('loading', 'lazy');
          replacement.setAttribute('data-bundle-inside-img', '');
          imgEl.replaceWith(replacement);
        }
      });
    }

    const PLAY_SVG = '<svg viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.8132 9.7124C24.2443 11.116 24.2443 14.625 21.8132 16.0286L5.89545 25.2187C3.46433 26.6223 0.425444 24.8678 0.425444 22.0606L0.425445 3.68038C0.425445 0.873174 3.46434 -0.881325 5.89545 0.522279L21.8132 9.7124Z" fill="#DFEAF5"/></svg>';

    function updateVideos(colorId) {
      const wrap = section.querySelector('[data-bundle-videos]');
      const row = section.querySelector('[data-bundle-videos-row]');
      if (!wrap || !row) return;
      const list = colorId ? colorVideos(colorId) : [];
      if (!list.length) {
        row.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) {} });
        row.innerHTML = '';
        wrap.hidden = true;
        return;
      }
      row.innerHTML = '';
      list.forEach(function (v, i) {
        const item = document.createElement('div');
        item.className = 'bct-siia__item';
        const video = document.createElement('video');
        video.id = 'bct-siia-video-' + i;
        video.preload = 'auto';
        video.playsInline = true;
        video.className = 'is-off';
        if (v.poster) video.poster = v.poster;
        const source = document.createElement('source');
        source.src = v.src;
        source.type = /\.mov($|\?)/i.test(v.src) ? 'video/mp4' : (/\.webm($|\?)/i.test(v.src) ? 'video/webm' : 'video/mp4');
        video.appendChild(source);
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bct-siia__btn';
        btn.setAttribute('aria-label', 'Play video ' + (i + 1));
        const play = document.createElement('span');
        play.className = 'bct-siia__play';
        play.innerHTML = PLAY_SVG;
        btn.appendChild(play);
        btn.addEventListener('click', function () {
          if (video.paused) { video.play(); video.classList.remove('is-off'); }
          else { video.pause(); video.classList.add('is-off'); }
        });
        item.appendChild(video);
        item.appendChild(btn);
        row.appendChild(item);
      });
      wrap.hidden = false;
    }

    function refreshTotal() {
      const allDone = config.items.every(isComplete);
      const oos = allDone ? currentSelectionOOS() : null;
      cta.classList.toggle('is-incomplete', !allDone);
      cta.classList.toggle('is-sold-out', !!oos);
      if (oos) {
        cta.disabled = true;
        cta.textContent = 'Out of Stock';
      } else {
        cta.disabled = false;
        cta.removeAttribute('disabled');
        cta.textContent = allDone ? 'Add to Cart' : 'Complete Your Selection';
      }
      if (totalEl) totalEl.textContent = money(meta.price);

      // Live savings: the dollar amount + percent off vs. retail (compare-at).
      const retail = Number(meta.retail) || 0;
      const price = Number(meta.price) || 0;
      const save = retail > price ? retail - price : 0;
      const savePct = save > 0 ? Math.round((save / retail) * 100) : 0;
      if (saveTextEl) saveTextEl.textContent = save > 0 ? 'You save ' + money(save) : 'You save';
      if (savePctEl && save > 0) savePctEl.textContent = savePct + '% OFF';
      const saveBadgeEl = section.querySelector('[data-bundle-save-badge]');
      if (saveBadgeEl && save > 0) saveBadgeEl.textContent = 'SAVE ' + savePct + '% OFF';
    }

    function firstIncompleteIdx() {
      for (let i = 0; i < config.items.length; i++) {
        if (!isComplete(config.items[i])) return i;
      }
      return -1;
    }

    function highlightMissing() {
      const idx = firstIncompleteIdx();
      if (idx < 0) return;
      const item = config.items[idx];
      config.items.forEach(function (it) { state[it.key].open = it.key === item.key; });
      renderItems();
      const card = itemsHost.querySelector('[data-key="' + item.key + '"]');
      if (card) {
        card.classList.add('bct__item--error');
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { card.classList.remove('bct__item--error'); }, 1800);
      }
    }

    function buildPayload() {
      const componentsPayload = [];
      config.items.forEach(function (item) {
        const sel = state[item.key].selections;
        const v = variantFor(item, sel);
        if (!v) return;
        const variantId = v.variantId || v.id;
        if (!variantId) return;
        componentsPayload.push({
          id: variantId,
          price: (v.price != null ? Number(v.price).toFixed(2) : '0.00'),
          quantity: item.qty || 1
        });
      });
      return componentsPayload;
    }

    // Rich per-component display info used by the storefront cart drawer to render
    // each bundle's expanded children with proper title, variant label, and image
    // (the CTF only sees `_components` and ignores these extra display fields).
    function buildDisplayPayload() {
      const displayPayload = [];
      config.items.forEach(function (item) {
        const sel = state[item.key].selections;
        const v = variantFor(item, sel);
        if (!v) return;
        const variantId = v.variantId || v.id;
        if (!variantId) return;
        const labelParts = [];
        (item.options || []).forEach(function (opt) {
          const choiceId = sel[opt.id];
          if (choiceId == null) return;
          const choice = (opt.choices || []).find(function (c) {
            return typeof c === 'string' ? c === choiceId : c.id === choiceId;
          });
          if (!choice) { labelParts.push(String(choiceId)); return; }
          labelParts.push(typeof choice === 'string' ? choice : (choice.name || choice.id));
        });
        let img = v.img || '';
        if (img) img = img.replace(/(\?|&)width=\d+/, '$1width=120');
        displayPayload.push({
          title: item.name,
          variant: labelParts.join(' · '),
          img: img,
          qty: item.qty || 1,
          price: (v.price != null ? Number(v.price).toFixed(2) : '0.00')
        });
      });
      return displayPayload;
    }

    cta.addEventListener('click', function () {
      if (!config.items.every(isComplete)) {
        highlightMissing();
        return;
      }
      // Strict inventory gate: never POST /cart/add.js for an OOS variant.
      const oos = currentSelectionOOS();
      if (oos) {
        const card = itemsHost.querySelector('[data-key="' + oos.item.key + '"]');
        if (card) {
          card.classList.add('bct__item--error');
          card.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function () { card.classList.remove('bct__item--error'); }, 1800);
        }
        return;
      }
      cta.disabled = true;
      const original = cta.textContent;
      cta.textContent = 'Adding…';

      const components = buildPayload();
      const addUrl = meta.cartAddUrl || '/cart/add.js';
      const headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

      // Selected-color hero image becomes the bundle thumbnail in cart/checkout.
      const mainImg = section.querySelector('[data-bundle-main-img]');
      let bundleHero = mainImg ? (mainImg.currentSrc || mainImg.src || '') : '';
      if (bundleHero) bundleHero = bundleHero.replace(/(\?|&)width=\d+/, '$1width=200');

      // Unique per-add identifier — keeps each "Add to Cart" click as its own
      // bundle group in the minicart, even when the same bundle is added in
      // different colors (or the same color twice).
      const bundleUid = 'bun_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);

      const componentsDisplay = buildDisplayPayload();
      const parentPayload = {
        items: [{
          id: meta.parentVariantId,
          quantity: 1,
          properties: {
            _components: JSON.stringify(components),
            _bundle_components_display: JSON.stringify(componentsDisplay),
            _bundle: meta.parentTitle,
            _bundle_name: meta.parentTitle,
            _bundle_image: bundleHero,
            _bundle_uid: bundleUid,
            // Dedicated marker — intentionally NOT _cart_type, which the Blissy
            // discount app uses as its own strategy trigger. Keeps bundle lines
            // from interfering with BOGO/dropcart logic on other products.
            _bundle_ct: '1'
          }
        }]
      };

      const componentItems = components.map(function (c) {
        return {
          id: variantIdNumeric(c.id),
          quantity: c.quantity || 1,
          properties: {
            _bundle: meta.parentTitle,
            _bundle_name: meta.parentTitle,
            _bundle_image: bundleHero,
            _bundle_uid: bundleUid,
            _bundle_ct: '1',
            _bundle_parent: String(meta.parentVariantId)
          }
        };
      });

      // Primary path: add the single bundle parent line with _components, which the
      // Cart Transform function expands into its component variants at checkout.
      // Safety fallback (until the function is confirmed live): if the parent add is
      // rejected, add the components directly so the cart still reflects the bundle.
      fetch(addUrl, { method: 'POST', headers: headers, body: JSON.stringify(parentPayload) })
        .then(function (r) {
          if (r.ok) {
            return r.json().then(function () { onAdded(); });
          }
          return r.text().then(function () {
            return fetch(addUrl, { method: 'POST', headers: headers, body: JSON.stringify({ items: componentItems }) })
              .then(function (r2) {
                if (r2.ok) return r2.json().then(function () { onAdded(); });
                return r2.text().then(function (txt2) {
                  let b2; try { b2 = JSON.parse(txt2); } catch (_) { b2 = { description: txt2 }; }
                  throw new Error((b2 && (b2.description || b2.message)) || ('HTTP ' + r2.status));
                });
              });
          });
        })
        .catch(function (err) {
          cta.disabled = false;
          cta.textContent = original;
          alert('Could not add bundle: ' + (err && err.message ? err.message : err));
        });

      function onAdded() {
        if (toast) {
          toast.hidden = false;
          const desc = toast.querySelector('.bct__toast-desc');
          if (desc) desc.textContent = meta.parentTitle + ' — ' + money(meta.price);
          setTimeout(function () { toast.hidden = true; }, 2400);
        }
        try {
          document.dispatchEvent(new CustomEvent('blissy:cart:added'));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('rebuy:cart.add'));
          document.dispatchEvent(new CustomEvent('rebuy:cart.change'));
        } catch (e) {}
        const openMinicart = function () {
          if (window.BlissyCart && typeof window.BlissyCart.open === 'function') {
            try { window.BlissyCart.open(); return true; } catch (e) {}
          }
          if (window.CartDrawer && typeof window.CartDrawer.show === 'function') {
            try { window.CartDrawer.show(); return true; } catch (e) {}
          }
          if (window.Rebuy && window.Rebuy.SmartCart) {
            try {
              if (typeof window.Rebuy.SmartCart.getCart === 'function') window.Rebuy.SmartCart.getCart();
              if (typeof window.Rebuy.SmartCart.show === 'function') window.Rebuy.SmartCart.show();
              return true;
            } catch (e) {}
          }
          return false;
        };
        if (!openMinicart()) {
          setTimeout(function () { if (!openMinicart()) window.location.href = meta.cartUrl || '/cart'; }, 400);
        }
        cta.disabled = false;
        cta.textContent = original;
      }
    });

    function variantIdNumeric(id) {
      if (!id) return id;
      const s = String(id);
      const m = s.match(/(\d+)$/);
      return m ? Number(m[1]) : s;
    }

    section.querySelectorAll('.bct__thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        section.querySelectorAll('.bct__thumb').forEach(function (b) { b.setAttribute('aria-selected', 'false'); });
        btn.setAttribute('aria-selected', 'true');
        const img = btn.querySelector('img');
        const main = section.querySelector('[data-bundle-main-img]');
        if (img && main) {
          main.src = img.src.replace(/width=\d+/, 'width=1200');
        }
      });
    });

    if (timerEl) {
      let s = 9 * 60 + 54;
      setInterval(function () {
        s = s > 0 ? s - 1 : 9 * 60 + 54;
        const m = String(Math.floor(s / 60)).padStart(2, '0');
        const r = String(s % 60).padStart(2, '0');
        timerEl.textContent = m + ':' + r;
      }, 1000);
    }

    function initialColor() {
      for (let i = 0; i < config.items.length; i++) {
        const it = config.items[i];
        const colorOpt = (it.options || []).find(function (o) { return o.id === 'color'; });
        if (colorOpt && colorOpt.default) return colorOpt.default;
      }
      return null;
    }
    // No color is pre-selected on init — the customer must explicitly pick a
    // swatch. Main image stays at product.featured_image (set in Liquid) and
    // the thumbnail rail stays on product.media. swapMainImage / syncThumbs
    // only fire from the click handler in pick().

    renderItems();
    refreshTotal();

    preloadInventory().then(function () {
      if (inventory == null) return;
      renderItems();
      refreshTotal();
    });
  })();

  // Smooth open/close for the right-panel accordions (Key Benefits + Details).
  // Native <details> snaps instantly; this intercepts the summary click and
  // animates body height + padding while keeping the open attribute in sync
  // for a11y. Per-detail isAnimating flag prevents rapid-click race conditions,
  // and a transitionend safety timeout finalizes state if the event misses.
  (function () {
    var EASE = 'cubic-bezier(0.4, 0, 0.2, 1)';
    var DUR = 320; // ms — keep in sync with the transition style below.
    var accordions = document.querySelectorAll('.bct__benefit, .bct__details');
    accordions.forEach(function (detail) {
      var summary = detail.querySelector(':scope > summary');
      var body = detail.querySelector(':scope > .bct__benefit-body, :scope > .bct__details-body');
      if (!summary || !body) return;

      body.style.overflow = 'hidden';
      body.style.boxSizing = 'content-box';
      body.style.transition = 'height ' + (DUR / 1000) + 's ' + EASE + ', padding ' + (DUR / 1000) + 's ' + EASE;

      if (!detail.hasAttribute('open')) {
        body.style.height = '0';
        body.style.paddingTop = '0';
        body.style.paddingBottom = '0';
      }

      var isAnimating = false;
      var safetyTimer = null;

      function finalize(opening) {
        if (opening) {
          body.style.height = '';
          body.style.paddingTop = '';
          body.style.paddingBottom = '';
        } else {
          detail.removeAttribute('open');
        }
        isAnimating = false;
        if (safetyTimer) { clearTimeout(safetyTimer); safetyTimer = null; }
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (isAnimating) return;
        isAnimating = true;
        var isOpen = detail.hasAttribute('open');

        if (isOpen) {
          // Close: explicit current height/padding -> 0
          var cs = window.getComputedStyle(body);
          body.style.height = body.scrollHeight + 'px';
          body.style.paddingTop = cs.paddingTop;
          body.style.paddingBottom = cs.paddingBottom;
          void body.offsetHeight; // reflow
          requestAnimationFrame(function () {
            body.style.height = '0';
            body.style.paddingTop = '0';
            body.style.paddingBottom = '0';
          });
          var onClose = function (ev) {
            if (ev.propertyName !== 'height') return;
            body.removeEventListener('transitionend', onClose);
            finalize(false);
          };
          body.addEventListener('transitionend', onClose);
          safetyTimer = setTimeout(function () {
            body.removeEventListener('transitionend', onClose);
            finalize(false);
          }, DUR + 80);
        } else {
          // Open: temporarily allow natural layout to read targets, then animate
          detail.setAttribute('open', '');
          body.style.removeProperty('height');
          body.style.removeProperty('padding-top');
          body.style.removeProperty('padding-bottom');
          var targetHeight = body.scrollHeight;
          var csOpen = window.getComputedStyle(body);
          var targetPT = csOpen.paddingTop;
          var targetPB = csOpen.paddingBottom;
          body.style.height = '0';
          body.style.paddingTop = '0';
          body.style.paddingBottom = '0';
          void body.offsetHeight; // reflow
          requestAnimationFrame(function () {
            body.style.height = targetHeight + 'px';
            body.style.paddingTop = targetPT;
            body.style.paddingBottom = targetPB;
          });
          var onOpen = function (ev) {
            if (ev.propertyName !== 'height') return;
            body.removeEventListener('transitionend', onOpen);
            finalize(true);
          };
          body.addEventListener('transitionend', onOpen);
          safetyTimer = setTimeout(function () {
            body.removeEventListener('transitionend', onOpen);
            finalize(true);
          }, DUR + 80);
        }
      });
    });
  })();

  // Thumbnail rail end-of-scroll detection — toggles .is-at-end on .bct__thumbs
  // so the chevron fades out when the last image is in view and reappears as
  // soon as the user scrolls back up.
  (function () {
    document.querySelectorAll('.bct__thumbs').forEach(function (rail) {
      if (!rail.querySelector('.bct__thumbs-more')) return;
      var update = function () {
        var atEnd = rail.scrollHeight - rail.scrollTop - rail.clientHeight <= 4;
        rail.classList.toggle('is-at-end', atEnd);
      };
      rail.addEventListener('scroll', update, { passive: true });
      // Initial sync (in case content is already short enough to be at-end).
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundler-2025-announcement"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
      const scrollTopElements = document.querySelectorAll(".announcment--scroll-top");
      if(scrollTopElements) {
        scrollTopElements.forEach(element => {
            element.addEventListener("click", ()=>{
               window.scrollTo({
                   top: 0,
                   behavior: 'smooth'
               });
            });
         });
      }

      const announcments = document.querySelector(".announcments");
      window.addEventListener("scroll", () => {
       if (announcments.getBoundingClientRect().bottom <= 0) {
         // Add sticky class when the element is completely out of view
         announcments.classList.add("announcments--sticky");
       } else if (window.scrollY === 0) {
         announcments.classList.remove("announcments--sticky");
       }
     });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundler-2025-header"] && !Shopify.designMode) return;
  try {
    
  // Function to add or remove class based on element visibility in the viewport
  function toggleBuyButton(element) {
    const elementPosition = element.getBoundingClientRect();
  
    // Check if the element is in the viewport
    if (elementPosition.top > 0 ) {
      document.querySelector(".header--nav").classList.add("header--nav--hidden");
    } else {
     document.querySelector(".header--nav").classList.remove("header--nav--hidden");
    }
  }
  
  document.addEventListener("DOMContentLoaded", () => {
    const buyBtn = document.querySelector(".buy-now");
    if(buyBtn) {
      buyBtn.addEventListener("click", (e)=>{
        e.preventDefault();
         if(document.querySelector("[data-cta-button]")) {
            document.querySelector("[data-cta-button]").scrollIntoView({
              behavior: 'smooth',
              block: "center"
          });
        } else {
          window.scrollTo({
              top: 0,
              behavior: 'smooth'
          });
        }

      })
    }
  });

  window.addEventListener('scroll', ()=> {
   
         if(document.querySelector("[data-cta-button")) {
           toggleBuyButton(document.querySelector("[data-cta-button"))
         }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creator-apply-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__blissyCreatorDialog) return;
    window.__blissyCreatorDialog = true;

    function getDialog() {
      return document.querySelector('[data-creator-dialog]');
    }

    // Keeps the scroll lock in sync however the dialog closes (Escape, close(), backdrop click).
    function bindDialog(dialog) {
      if (dialog.dataset.creatorBound) return;
      dialog.dataset.creatorBound = 'true';
      new MutationObserver(function () {
        document.documentElement.classList.toggle('crt-dialog-open', dialog.open);
      }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    }

    function openDialog(dialog) {
      dialog = dialog || getDialog();
      if (!dialog || dialog.open) return;
      bindDialog(dialog);
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      document.documentElement.classList.add('crt-dialog-open');
      var firstField = dialog.querySelector('input:not([type="hidden"]), select');
      if (firstField) firstField.focus();
    }

    function closeDialog(dialog) {
      dialog = dialog || getDialog();
      if (!dialog) return;
      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
      document.documentElement.classList.remove('crt-dialog-open');
    }

    // Shopify re-renders the page after a rejected submission and only echoes the email back,
    // so the other answers are kept in sessionStorage for that round trip and cleared on success.
    var STORAGE_KEY = 'blissy-creator-application';

    function fieldsOf(dialog) {
      return dialog.querySelectorAll('input:not([type="hidden"]):not([tabindex="-1"]), select');
    }

    function saveAnswers(dialog) {
      var answers = {};
      fieldsOf(dialog).forEach(function (field) { if (field.name) answers[field.name] = field.value; });
      try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(answers)); } catch (error) { /* storage unavailable */ }
    }

    function restoreAnswers(dialog) {
      var answers;
      try { answers = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}'); } catch (error) { answers = {}; }
      fieldsOf(dialog).forEach(function (field) {
        if (!field.value && typeof answers[field.name] === 'string') field.value = answers[field.name];
      });
    }

    function clearAnswers() {
      try { sessionStorage.removeItem(STORAGE_KEY); } catch (error) { /* storage unavailable */ }
    }

    function autoOpen() {
      var dialog = getDialog();
      if (!dialog) return;
      bindDialog(dialog);
      if (dialog.querySelector('.crt-form__success')) clearAnswers();
      else if (dialog.querySelector('.crt-form__errors')) restoreAnswers(dialog);
      if (dialog.querySelector('[data-creator-dialog-autoopen]')) openDialog(dialog);
    }

    document.addEventListener('submit', function (event) {
      var dialog = event.target.closest && event.target.closest('[data-creator-dialog]');
      if (dialog) saveAnswers(dialog);
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-creator-apply]')) {
        event.preventDefault();
        openDialog();
        return;
      }
      if (event.target.closest('[data-creator-dialog-close]')) {
        closeDialog();
        return;
      }
      var dialog = getDialog();
      if (dialog && event.target === dialog) closeDialog(dialog);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', autoOpen);
    } else {
      autoOpen();
    }
    document.addEventListener('shopify:section:load', autoOpen);
    document.addEventListener('shopify:section:select', function (event) {
      var dialog = event.target.querySelector('[data-creator-dialog]');
      if (dialog) openDialog(dialog);
    });
    document.addEventListener('shopify:section:deselect', function (event) {
      var dialog = event.target.querySelector('[data-creator-dialog]');
      if (dialog) closeDialog(dialog);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creator-benefits"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__blissyCreatorAccordion) return;
    window.__blissyCreatorAccordion = true;

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.crt-accordion__trigger');
      if (!trigger) return;
      var accordion = trigger.closest('[data-creator-accordion]');
      if (!accordion) return;
      var wasOpen = trigger.getAttribute('aria-expanded') === 'true';

      accordion.querySelectorAll('.crt-accordion__trigger').forEach(function (other) {
        var open = other === trigger && !wasOpen;
        var panel = document.getElementById(other.getAttribute('aria-controls'));
        other.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) panel.hidden = !open;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creator-calculator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__blissyCreatorCalc) return;
    window.__blissyCreatorCalc = true;

    function formatNumber(n) {
      return Math.round(n).toLocaleString('en-US');
    }

    function update(calc, orders) {
      if (!calc) return;
      var rate = Number(calc.dataset.rate) || 0;
      var aov = Number(calc.dataset.aov) || 0;
      var range = calc.querySelector('[data-calc-range]');
      var ordersOut = calc.querySelector('[data-calc-orders]');
      var monthlyOut = calc.querySelector('[data-calc-monthly]');
      var yearlyOut = calc.querySelector('[data-calc-yearly]');

      if (range) {
        if (Number(range.value) !== orders) range.value = orders;
        // The browser clamps and snaps the value to min/max/step; use that so every figure matches the slider.
        orders = Number(range.value);
        range.setAttribute('aria-valuetext', formatNumber(orders) + ' orders per month');
      }
      var monthly = (orders * aov * rate) / 100;
      if (ordersOut) ordersOut.textContent = formatNumber(orders);
      if (monthlyOut) monthlyOut.textContent = '$' + formatNumber(monthly);
      if (yearlyOut) yearlyOut.textContent = '$' + formatNumber(monthly * 12);
      calc.querySelectorAll('[data-calc-preset]').forEach(function (button) {
        button.setAttribute('aria-pressed', Number(button.dataset.calcPreset) === orders ? 'true' : 'false');
      });
    }

    function initAll() {
      document.querySelectorAll('[data-creator-calc]').forEach(function (calc) {
        var range = calc.querySelector('[data-calc-range]');
        if (range) update(calc, Number(range.value));
      });
    }

    document.addEventListener('input', function (event) {
      var range = event.target.closest('[data-calc-range]');
      if (range) update(range.closest('[data-creator-calc]'), Number(range.value));
    });

    document.addEventListener('click', function (event) {
      var preset = event.target.closest('[data-calc-preset]');
      if (preset) update(preset.closest('[data-creator-calc]'), Number(preset.dataset.calcPreset));
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
if (!customElements.get('blissy-search-results')) {
  customElements.define('blissy-search-results', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const initialURL = new URL(window.location.href);
      if (initialURL.searchParams.get('q') && !initialURL.searchParams.get('type')) {
        initialURL.searchParams.set('type', 'product');
        window.location.replace(initialURL.href);
        return;
      }
      this.abort = new AbortController();
      this.groups = new Map();
      this.limit = Number(this.dataset.pageSize) || 24;
      this.grid = this.querySelector('.blissy-search__grid');
      this.more = this.querySelector('[data-load-more]');
      this.status = this.querySelector('[data-load-status]');
      this.next = this.querySelector('[data-search-next]')?.getAttribute('href') || '';
      this.dialog = this.querySelector('dialog');
      this.sidebar = this.querySelector('.blissy-search__sidebar');
      this.panel = this.querySelector('[data-filter-panel]');
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('input', this.onFilterSearch.bind(this));
      this.addEventListener('submit', (event) => {
        if (!event.target.matches('.blissy-search__filter-form')) return;
        event.target.querySelectorAll('input[type=number]').forEach(input => { input.disabled = !input.value; });
      });
      this.dialog?.addEventListener('close', () => {
        this.sidebar.append(this.panel);
        document.body.style.overflow = this.bodyOverflow;
        this.querySelector('[data-filter-open]')?.focus({preventScroll:true});
      });
      this.dialog?.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      if (this.grid) {
        this.merge([...this.grid.children]);
        this.querySelector('[data-search-pagination]').hidden = true;
        this.renderGroups();
        this.fill();
        if ('IntersectionObserver' in window) {
          this.autoLoad = true;
          this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting) && !this.loading && !this.failed && this.hasMore()) {
              this.limit += Number(this.dataset.pageSize) || 24;
              this.fill();
            }
          }, {rootMargin:'300px 0px'});
          this.observer.observe(this.querySelector('.blissy-search__more'));
          this.renderGroups();
        }
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      if (this.dialog?.open) this.dialog.close();
    }
    onChange(event) {
      const control = event.target;
      if (!control.matches('[data-search-param]')) return;
      const url = new URL(window.location.href);
      const name = control.dataset.searchParam;
      if (control.value) url.searchParams.set(name, control.value);
      else url.searchParams.delete(name);
      url.searchParams.delete('page');
      if (name === 'type') this.clearParams(url);
      window.location.assign(url.href);
    }
    clearParams(url) {
      for (const key of [...url.searchParams.keys()]) {
        if (key.startsWith('filter.') || key === 'page') url.searchParams.delete(key);
      }
    }
    onClick(event) {
      if (event.target.closest('[data-search-clear]')) {
        const url = new URL(window.location.href);
        this.clearParams(url);
        window.location.assign(url.href);
      } else if (event.target.closest('[data-filter-open]')) {
        this.bodyOverflow = document.body.style.overflow;
        this.dialog.append(this.panel);
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
      } else if (event.target.closest('[data-filter-close]')) {
        this.dialog.close();
      } else if (event.target.closest('[data-load-more]')) {
        if (this.loading) return;
        this.limit += Number(this.dataset.pageSize) || 24;
        this.fill();
      }
    }
    onFilterSearch(event) {
      if (!event.target.matches('[data-facet-search]')) return;
      const normalize = value => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/-/g, ' ');
      const term = normalize(event.target.value.trim());
      const facet = event.target.closest('details');
      const options = [...facet.querySelectorAll('[data-facet-value]')];
      options.forEach(option => { option.hidden = !normalize(option.dataset.facetValue).includes(term); });
      facet.querySelector('[data-facet-empty]').hidden = options.some(option => !option.hidden);
    }
    merge(items) {
      const sort = new URL(window.location.href).searchParams.get('sort_by') || 'relevance';
      for (const item of items) {
        const key = item.dataset.resultKey;
        if (!key) continue;
        const existing = this.groups.get(key);
        if (!existing) this.groups.set(key, item);
        else if (sort === 'relevance' && Number(item.dataset.resultPreference) > Number(existing.dataset.resultPreference)) {
          this.groups.set(key, item);
          existing.remove();
        }
        if (this.groups.get(key) !== item) item.remove();
      }
    }
    hasMore() {
      return Boolean(this.next) || this.groups.size > this.limit;
    }
    renderGroups() {
      let index = 0;
      for (const item of this.groups.values()) {
        item.hidden = index++ >= this.limit;
        if (item.parentElement !== this.grid) this.grid.append(item);
      }
      const ordered = [...this.groups.values()];
      ordered.forEach((item,index) => { if (this.grid.children[index] !== item) this.grid.insertBefore(item,this.grid.children[index] || null); });
      this.more.hidden = !this.hasMore() || (this.autoLoad && !this.failed);
      window.calculateBogoEachPrices?.(this.grid);
      window.applyBlissyCardPromotion?.(this.grid);
    }
    async fill() {
      if (this.loading) return;
      this.loading = true;
      this.failed = false;
      this.more.disabled = true;
      this.grid.setAttribute('aria-busy', 'true');
      this.status.textContent = '';
      this.renderGroups();
      try {
        while (this.groups.size < this.limit && this.next) {
          this.status.textContent = this.dataset.loading;
          const url = new URL(this.next, window.location.href);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, {signal:this.abort.signal});
          if (!response.ok) throw new Error('Search results unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const results = doc.querySelector('blissy-search-results');
          if (!results) throw new Error('Search results missing');
          this.merge([...results.querySelectorAll('.blissy-search__grid > [data-result-key]')]);
          const next = results.querySelector('[data-search-next]')?.getAttribute('href') || '';
          if (next && new URL(next,window.location.href).searchParams.get('page') === url.searchParams.get('page')) throw new Error('Search page did not advance');
          this.next = next;
          this.renderGroups();
        }
        this.status.textContent = '';
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.failed = true;
          this.status.textContent = this.dataset.loadError;
        }
      } finally {
        this.loading = false;
        this.more.disabled = false;
        this.grid.removeAttribute('aria-busy');
        this.renderGroups();
        window.StampedFn?.reloadUGC?.();
        if (this.observer && !this.failed && this.hasMore()) {
          this.observer.unobserve(this.querySelector('.blissy-search__more'));
          this.observer.observe(this.querySelector('.blissy-search__more'));
        }
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
